<template>
  <div class="home_wrap">
    <van-nav-bar
      title="Agente"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <van-tabs
      v-model="active"
      animated
      sticky
      offset-top="1.2rem"
      lazy-render
      class="vantTabs"
      @change="changeTabs"
    >
      <van-tab
        v-for="(item, index) in tabList"
        :key="item.title"
        :title="item.title"
      >
        <template v-if="item.components">
          <components
            :is="item.components"
            v-if="[1, 9].includes(active)"
            @changeActive="changeActive"
          />
          <components
            :is="item.components"
            v-else-if="[0].includes(active)"
            @changeActive="changeActive"
            @custom-event="handleEvent"
          />
          <components
            :is="item.components"
            v-else
            :list="list"
            :active="active"
            @getList="getList"
          />
        </template>
        <template v-else>
          内容{{ index }}
        </template>
      </van-tab>
    </van-tabs>

    <div
      v-if="Object.keys(total).length && [2, 3, 6].includes(active)"
      class="total_box"
    >
      <div
        v-for="item in totalInfo"
        :key="item.key"
        class="total_item"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <div class="key">
          {{ total[item.key] }}
        </div>
      </div>
    </div>
    <ft />
    <van-popup
      v-model="show"
      position="center"
      :style="{ height: '70%', width: '95%', margin: '0 auto' }"
    >
      <div class="his-title">
        História
      </div>
      <div class="his-change">
        <div class="select_items">
          <div class="select_item">
            <select
              id="withdraw"
              v-model="select_withdraw_time"
              name="withdraw"
              class="amount-input selectpix"
              @change="selectWithdrawTimeChange"
            >
              <option
                value="yesterday"
                :selected="select_withdraw_time == 'yesterday'"
              >
                Ontem
              </option>
              <option
                value="today"
                :selected="select_withdraw_time == 'today'"
              >
                Hoje
              </option>
              <option
                value="week"
                :selected="select_withdraw_time == 'week'"
              >
                Está Semana
              </option>
              <option
                value="last week"
                :selected="select_withdraw_time == 'last week'"
              >
                Última Semana
              </option>
              <option
                value="month"
                :selected="select_withdraw_time == 'month'"
              >
                Este Mês
              </option>
              <option
                value="last month"
                :selected="select_withdraw_time == 'last month'"
              >
                Mês Passado
              </option>
              <option
                value="all"
                :selected="select_withdraw_time == 'all'"
              >
                Tudo
              </option>
              <option
                value="custom"
                :selected="select_withdraw_time == 'custom'"
              >
                Personalizar
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="select_withdraw_time == 'custom'"
          class="datePicker"
        >
          <el-date-picker
            ref="datePicker"
            v-model="value"
            class="datePicker"
            type="daterange"
            range-separator="-"
            start-placeholder="start-time"
            end-placeholder="end-time"
            append-to-body
            value-format="yyyy-MM-dd"
            popper-class="popPicker"
            @change="changeDate"
          />
        </div>
      </div>
      <div class="statistics">
        <div>
          <p>Näo recolhido</p>
          <p class="yellow">
            {{ info.unreceived }}
          </p>
        </div>
        <div>
          <p>Resgatado</p>
          <p class="yellow">
            {{ info.received }}
          </p>
        </div>
      </div>
      <div v-if="info.list.length !== 0">
        <div
          v-for="(item, index) in info.list"
          class="his-content"
          style="margin-bottom: .5rem;"
        >
          <div class="content-top">
            <div class="top-left">
              <div>Hora de lancamento</div>
              <div style="color: #000;margin-top: .2rem;">
                {{ item.sendtime }}
              </div>
            </div>
            <div class="top-right">
              <div>Comissao</div>
              <div style="color: #f3b457;margin-left: .2rem;">
                {{ item.total }}
              </div>
            </div>
          </div>
          <div
            class="content-top"
            style="margin-top: .4rem;"
          >
            <div class="top-left">
              <div>Hora da coleta</div>
              <div style="color: #000;margin-top: .2rem;">
                {{ item.createtime }}
              </div>
            </div>
            <div class="top-right">
              <div>Estado </div>
              <div style="color: #58b556;margin-left: .2rem;">
                {{ item.status_text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Empty v-else />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { NavBar, Tab, Tabs, Popup } from 'vant';
import ft from "../../components/ft"
import Fetch from '../../utils/fetch';
import convite from './components/convite.vue';
import meus from './components/meus.vue';
import list from './components/list.vue';
import taxa from './components/taxa.vue';
import totalData from './totalInfo.json';
import Empty from '../../components/empty.vue';
Vue.use(NavBar).use(Popup);
export default {
  name: "Agent",
  components: {
    ft,
    vanTab: Tab,
    vanTabs: Tabs,
    convite,
    meus,
    list,
    taxa,
    Empty
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      show_icon_type: 'about',
      data: {},
      value: "",
      active: 0,
      show: false,
      select_withdraw_time: "yesterday",
      tabList: [
        {
          title: 'Link de Convite',
          components: 'convite'
        },
        {
          title: 'Meus Dados',
          components: 'meus'
        },
        {
          title: 'Todos os Dados',
          components: 'list'
        },
        {
          title: 'Desempenho',
          components: 'list'
        },
        {
          title: 'Comissão',
          components: 'list'
        },
        {
          title: 'Dados do Subordinado',
          components: 'list'
        },
        {
          title: 'Apostas dos Subordinados',
          components: 'list'
        },
        {
          title: 'Finanças dos Subordinados',
          components: 'list'
        },
        {
          title: 'Resgates dos subordinados',
          components: 'list'
        },
        {
          title: 'Taxa de Comissão',
          components: 'taxa'
        }
      ],
      totalInfo: [],
      total: {},
      list: [],
      params: {},
      info: {
        list: []
      }
    };
  },
  created() {
  },
  mounted() {
    this.start();
    if (this.$route.query.index) {
      this.$parent.act_active = 0;
    } else {
      this.$parent.isShowBottom = false;
    }
  },
  methods: {
    changeActive(active) {
      this.active = active
      this.changeTabs(active)
    },
    handleEvent(data) {
      this.show = data.show;
      this.getHistData();
    },
    selectWithdrawTimeChange() {
      this.info = {
        list: []
      };
      if (this.select_withdraw_time !== "custom") {
        this.getHistData();
      } else {
        this.getHis();
      }

    },
    getHis() {
      this.$message({
        message: 'Por favor escolha um momento de começo e fim',
        type: 'warning',
        customClass: "warnMess",
        center: true
      });
      this.value = ""
    },
    getCData() {
      Fetch("/agent/history", {
        date: this.select_withdraw_time,
        start: this.params.startDate,
        end: this.params.endDate
      }).then(res => {
        if (res.data) {
          this.info = res.data;
        }
      })
    },
    getHistData() {
      Fetch("/agent/history", {
        date: this.select_withdraw_time
      }).then(res => {
        if (res.data) {
          this.info = res.data;
        }
      })
    },
    getList(params) {
      switch (this.active) {
        case 2:
          Fetch('/agent/allData', params).then(res => {
            this.list = res.data.page
            this.total = res.data.otherData
          })
          break;
        case 3:
          Fetch('/agent/performance', params).then(res => {
            this.list = res.data.page
            this.total = res.data.otherData
          })
          break;
        case 4:
          // Fetch('/agent/subActive', params).then(res => {
          //   this.list = res.data.page
          //   this.total = res.data.otherData
          // })
          break;
        case 5:
          Fetch('/agent/subActive', params).then(res => {
            this.list = res.data.records
            this.total = {}
          })
          break;
        case 6:
          Fetch('/agent/subBetReport', params).then(res => {
            this.list = res.data.records
            this.total = res.data.otherData
          })
          this.totalInfo = totalData.t3
          break;
        case 7:
          // this.getList()
          this.totalInfo = totalData.t4
          break;
      }
    },
    changeDate(e) {
      this.params.startDate = e[0]
      this.params.endDate = e[1]
      this.value = [new Date(e[0]), new Date(e[1])]
      // this.$emit('getList', this.params)
      this.getCData();
    },
    start() {
      // Fetch('/index/about').then((r) => {
      //   this.data = r.data;
      // });
    },
    onClickLeft() {
      this.$router.push("/");
    },
    changeTabs(e) {
      this.list = []
      this.totalInfo = {}
      switch (e) {
        case 2:
          this.getList()
          this.totalInfo = totalData.t1
          break;
        case 3:
          this.getList()
          this.totalInfo = totalData.t2
          break;
        case 5:
          this.getList()
          this.totalInfo = {}
          break;
        case 6:
          this.getList()
          this.totalInfo = totalData.t3
          break;
        case 7:
          this.getList()
          this.totalInfo = totalData.t4
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar--fixed {
  z-index: 2;
}

/deep/ .van-nav-bar {
  background: @primary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: @textcolor1;
}

/deep/ .van-nav-bar__title {
  color: @textcolor1;
}

@media (min-width: @maxWidth) {
  :deep(.van-sticky) {
    position: static !important;
  }
}

.popPicker {
  z-index: 9999;
}

.datePicker {
  display: flex;
  padding: 10px;


  :deep(.el-date-editor) {
    width: 190px;
    background-color: @secondary-color;
    border-color: @bodercolor;
    border-radius: 50px;
    height: 28px;

    .el-range-input {
      height: 20px;
      font-size: 12px;
      color: @textcolorf;
      background-color: transparent;
    }

    .el-range-separator {
      color: @textcolorf;
      height: 28px;
      line-height: 26px;

    }

    .el-input__icon {
      display: none;
    }
  }

  :deep(.van-search) {
    width: 105px;
    padding: 0;
    height: 28px;
    border-radius: 28px;
    background-color: @secondary-color;
    margin-left: 10px;

    .van-search__content {
      border-radius: 28px;
      border: 1px solid @bodercolor;
      background-color: @secondary-color;
    }

    .van-icon {
      color: @textcolorf;
    }

    .van-cell {
      padding: 0 8px 0 0;

      input {
        font-size: 11px;
        color: @textcolorf;

        &::placeholder {
          font-size: 10px;
        }
      }
    }
  }
}

/deep/ .van-popup--center {
  border-radius: 0.3rem;
  background-color: @secondary-color;
  padding-left: .3rem;
  padding-right: .3rem;

  box-sizing: border-box;
}

.his-title {
  font-size: .55rem;
  // margin: 0 auto;
  color: @textcolor1;
  text-align: center;
  margin-top: .3rem;
}

.select_items {
  display: flex;
  // justify-content: space-around;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

select {
  border-radius: 0.5rem;
  color: #bdc4b9;
  background-color: @secondary-color;
  padding: 0.15rem 0.2rem;
  border: 0.01rem solid @bodercolor;
  // color: #ccc;
  font-size: 0.3rem;
}

.statistics {
  display: flex;
  justify-content: space-around;

  div {
    display: flex;
    // margin-right: .3rem;
    font-size: .32rem;
    color: @textcolor1;

    .yellow {
      margin-left: .2rem;
      color: #f3b457;
    }

    .blank {
      margin-left: .2rem;
      color: #000;
    }
  }
}

.his-content {
  width: 100%;
  padding: .3rem;
  background-color: @primary-color;
  margin-right: .3rem;
  box-sizing: border-box;
  border-radius: .2rem;
  color: @textcolor1;
  font-size: .3rem;

  .content-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .top-right {
      display: flex;
    }
  }
}

.his-change {
  display: flex;
  align-items: center;
}

.vantTabs {

  :deep(.van-sticky) {
    width: 100%;
    max-width: @maxWidth;
    // left: 50%;
    // transform: translateX(-50%);
  }

  :deep(.van-tabs__wrap) {
    height: 0.88rem;

    .van-tabs__nav {
      padding-left: 0;
      padding-right: 0;
      background-color: @secondary-color;
    }

    .van-tab {
      padding: 0 0.2rem;

      .van-tab__text {
        font-size: .32rem;
      }

      &.van-tab--active {
        span {
          color: @rechargeColor;
        }
      }
    }

    .van-tabs__line {
      background-color: @rechargeColor;
    }
  }
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: @activityColor;
  padding-top: 1.2rem;
}

.total_box {
  // position: fixed;
  // bottom: 60px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background-color: @secondary-color;
  padding: 5px 10px;
  border-top: 1px solid @bodercolor;

  .total_item {
    display: flex;

    .title {
      width: 80px;
      font-size: 10px;
      margin-bottom: 6px;
      color: @textcolorf;
      margin-right: 4px;
    }

    .key {
      color: @textcolor1;
    }

    &:nth-last-child(1) .key,
    &:nth-last-child(2) .key {
      color: @textcolor4;
    }
  }

  div {
    width: 50%;
  }
}
</style>
